import { IStorage } from "tessa/platform/storage";
import { createTypedField, DotNetType } from "tessa/platform";
import { CardRequest, CardService } from "tessa/cards/service";
import { ChRequestTypes } from "./ChRequestTypes";
import { userSession } from "common/utility";

export class PkCommonHelper {

  public static IsNullOrWhitespace( input ) {
    if (typeof input === 'undefined' || input == null) return true;
    return input.replace(/\s/g, '').length < 1;
  }

  public static GetDateTimeNow(addDay) {
    let dateNow = new Date();
    if (addDay) {
      dateNow.setDate(dateNow.getDate() + addDay);
    }
    let result = dateNow.getFullYear() + "-" +
    PkCommonHelper.ConvertTwoSymbols(dateNow.getMonth() + 1) + "-" +
    PkCommonHelper.ConvertTwoSymbols(dateNow.getDate()) + "T" +
    dateNow.toLocaleTimeString('ru-RU') + "Z";
    return result;
  }

  private static ConvertTwoSymbols(value) {
    if (value.toString().length === 1) {
      value = "0" + value;
    }
    return value;
  }

  public static AddListToInfo(info: IStorage, key: string, list, type: DotNetType) {
    let result: any[] = [];
    list.forEach(element => {
      result.push(createTypedField(element, type));
    });
    info[key] = result;
  }


  public static financial(x) {
    return parseFloat(Number.parseFloat(x).toFixed(2));
  }

  public static saveByteArray(reportName, byte, docType) {
    var blob = new Blob([byte], { type: docType });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    var fileName = reportName;
    link.download = fileName;
    link.click();
  };

  public static SaveFileContent(fileName: string, fileContent: Blob) {
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(fileContent);
    link.download = fileName;
    link.click();
  }

  public static async GetBase64String(fileContent: Blob) {
    // @ts-ignore
    const content = await fileContent.arrayBuffer();
    const data = new Uint8Array(content);

    // конвертируем контент файла в строку
    const fileContentString = btoa(
    data.reduce(function (data, byte) {
        return data + String.fromCharCode(byte);
    }, ''));

    // возвращаем контент файла в виде base64 строки
    return fileContentString;
  }
  
  public static base64ToArrayBuffer(base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  public static GroupBy = <T, K extends keyof any>(list: T[], getKey: (item: T) => K) =>
    list.reduce((previous, currentItem) => {
      const group = getKey(currentItem);
      if (!previous[group]) previous[group] = [];
      previous[group].push(currentItem);
      return previous;
  }, {} as Record<K, T[]>);

  public static async CheckCurrentUserInRole(roleId: string) {
      const request = new CardRequest();
      request.requestType = ChRequestTypes.CheckUserInRole
      request.info["UserID"] = createTypedField(userSession.UserID, DotNetType.Guid);
      request.info["RoleID"] = createTypedField(roleId, DotNetType.Guid);

      const response = await CardService.instance.request(request);

      if (response.validationResult.build().isSuccessful)
      {
          return response.info.IsUserInRole.$value;
      }
      
      return false
  }
}